import { createPortal } from 'react-dom';
import { Box } from '@mui/material';

import { ReactEditor, useSlate } from 'slate-react';
import { Node, Text } from 'slate';
import {
    Column,
    Container,
    InnerElement,
    Placeholder,
    Row,
    Section,
} from '@InteractiveComponents/interactiveElements';
import useEmailEditor from '@hooks/useEmailEditor';

function RenderOverlay({ element }) {
    const { type: elementType, children: nodeChildren } = element;
    const editor = useSlate();
    const getKey = n => ReactEditor.findKey(editor, n).id;
    if (Text.isText(element)) return null;
    if (nodeChildren.length === 0) return null;
    const children = nodeChildren.map(n => (
        <RenderOverlay element={n} key={getKey(n)} />
    ));

    let path;

    try {
        path = ReactEditor.findPath(editor, element);
    } catch {
        return null;
    }

    switch (elementType) {
        case 'container':
            return (
                <Container node={element} path={path}>
                    {children}
                </Container>
            );
        case 'section':
            return (
                <Section node={element} path={path}>
                    {children}
                </Section>
            );
        case 'placeholder':
            return (
                <Placeholder node={element} path={path}>
                    {children}
                </Placeholder>
            );
        case 'row':
            return (
                <Row node={element} path={path}>
                    {children}
                </Row>
            );
        case 'column':
            return (
                <Column node={element} path={path}>
                    {children}
                </Column>
            );
        case 'rich-text':
        case 'button':
        case 'divider':
        case 'spacer':
        case 'image':
            return <InnerElement node={element} path={path} />;
        default:
            return children;
    }
}

const OverlayContainer = () => {
    const editor = useSlate();
    const { draggedElement } = useEmailEditor();

    return (
        <Box
            id="editor-overlay"
            sx={{
                position: 'absolute',
                pointerEvents: draggedElement ? 'auto' : 'none',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
            }}
        >
            <RenderOverlay element={editor.children[0]} key="0" />
        </Box>
    );
};

export function Overlay() {
    return createPortal(
        <OverlayContainer />,
        document.getElementById('iframe-container'),
    );
}
